@if (!carregando) {
  <div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
    <!-- Título -->
    <div class="bg-light pt-3 pr-4 pb-3 pl-4">
      <div class="titulo_texto">Importações</div>
    </div>
    <ul ngbNav #t="ngbNav" class="nav-tabs" (navChange)="alterarAbas($event)" [(activeId)]="tabSelecionada">
      <!-- Clientes -->
      <li [ngbNavItem]="'clientes'">
        <a ngbNavLink>
          <b>Clientes</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <app-importacoes-clientes></app-importacoes-clientes>
          </div>
        </ng-template>
      </li>
      <!-- Produtos -->
      <li [ngbNavItem]="'produtos'">
        <a ngbNavLink>
          <b>Produtos</b>
        </a>
        <ng-template ngbNavContent>
          <div class="pt-3 pr-4 pb-4 pl-4" [@esvanecerDesvanecer]="'in'">
            <app-importacoes-produtos></app-importacoes-produtos>
          </div>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="t"></div>
  </div>
}
